import { CdsContentPanel } from 'clayco-component-library/lib';
import React, {useCallback, useEffect, useState} from 'react';
import { FormatDateToLocal } from '../../../utility/conversions';
import Spinner from '../../skills-experience/shared/spinner';
import AddressReview from './addressReview';
import NameReview from './nameReview';
import ContactInfoReview from './contactInfoReview';
import { set } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const ChangeReview = ({show, setShow, changeInfo, apiProvider, reloadChange, setReloadChange})=> {
    const [details, setDetails] = useState();
    const [loading, setLoading] = useState(false);
    const [changeType, setChangeType] = useState();
    const [reviewBody, setReviewBody] = useState(<></>);
    const navigate = useNavigate();


    const loadDetailsChange = useCallback(async (ct, en) => {
        setLoading(true);
        determineBody();
        let result = await apiProvider.Get(`Profile/GetChangeForUser/${ct}/${en}`);
        if (result && !result.error){
            setChangeType(changeInfo?.changeType);
            setDetails(result);
        }
        console.log("INFO", result);
        console.log("INFO@", changeInfo)
        setLoading(false);
    }, []);

    useEffect(()=> {
        if (changeInfo){
            loadDetailsChange(changeInfo?.changeType, changeInfo?.employeeNumber);
        }
    }, [changeInfo]);

    function getTitle() {
        return (
            <>
                {changeInfo?.employeeName}
                <span className="ms-3 cds-text-light-italic">
                    {changeInfo?.employeeNumber}
                </span>
                <span
                    className="cds-text-light"
                    style={{ float: 'right' }}
                >
                    {FormatDateToLocal(changeInfo?.modifiedOn)}
                </span>
            </>
        );
    }

    function determineBody(){
        let jsx = <></>;

        switch(changeInfo?.changeType){
            case 1:
                jsx = <AddressReview data={details} apiProvider={apiProvider} reloadChange = {reloadChange} setReloadChange = {setReloadChange}/>
                break;
            case 2:
                jsx = <NameReview data={details} apiProvider={apiProvider} reloadChange = {reloadChange} setReloadChange = {setReloadChange}/>
                break;
            case 3:
            case 4:
            default:
            break;
        }

        setReviewBody(jsx);
    }

    async function handleApprove(){
        //setReloadChange(!reloadChange);
        setLoading(true);
        console.debug('For sure, my pleasure my treasure');
        let result = await apiProvider.Post(`Profile/Admin/Approve`, changeInfo);

        if (result && result.error !== undefined){
            //handle error
            return;
        }
        navigate('/Profile/Admin');
        setShow(false);
        setLoading(false);
        
    }

    async function handleReject(){
        setLoading(true);
        console.debug('No way Jose');
        let result = await apiProvider.Patch(`Profile/Admin/Reject`, changeInfo);

        if (result && result.error !== undefined){
            //handle error
            return;
        }
        
        // handle success
        setShow(false);
        setLoading(false);
    }
    
    return(
        <>
        <div className='ms-0 me-auto'>
            <a onClick={()=>setShow(false)}>{'< Back'}</a>
        </div>
        <CdsContentPanel
            title={<>{getTitle()}</>}
            primaryButtonText={'Approve'}
            secondaryButtonText={'Reject'}
            primaryButtonHandler={handleApprove}
            secondaryButtonHandler={handleReject}
        >
            {/* todo: refactor this */}
        {
            loading ? 
            <Spinner show={loading} />
            :
            <>
            {
                (changeType === 1) ?
                    <AddressReview data={details} apiProvider={apiProvider} reloadDetails={loadDetailsChange}  reloadChange = {reloadChange} setReloadChange = {setReloadChange}/>
                : changeType === 2 ?
                    <NameReview data={details} apiProvider={apiProvider} reloadDetails={loadDetailsChange} reloadChange = {reloadChange} setReloadChange = {setReloadChange}/>
                : changeType === 3 ?
                    <ContactInfoReview data={details} />
                : <></> 
                
            }
            </>
        }
        </CdsContentPanel>
        </>
    )
}

export default ChangeReview;